var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("header", { staticClass: "header" }, [
        _c(
          "div",
          {
            staticClass: "back",
            on: {
              click: function ($event) {
                return _vm.$router.back()
              },
            },
          },
          [
            _c("img", {
              attrs: { src: require("images/back.png"), width: "10" },
            }),
            _c("span", [_vm._v("返回")]),
          ]
        ),
      ]),
      _c("div", { staticClass: "info-wrapper" }, [
        _c("div", { staticClass: "info" }, [
          _c("h4", [_vm._v(_vm._s(_vm.examName))]),
          _c("span", { staticClass: "stud-info" }, [
            _vm._v(
              _vm._s(_vm.gradeName) +
                " " +
                _vm._s(_vm.className) +
                "班 " +
                _vm._s(_vm.studentName) +
                " "
            ),
          ]),
        ]),
        _c(
          "div",
          {
            directives: [
              {
                name: "loading",
                rawName: "v-loading",
                value: _vm.dataLoading,
                expression: "dataLoading",
              },
            ],
            staticClass: "preview-common-box",
          },
          [
            _c(
              "el-button",
              {
                attrs: { type: "primary", plain: "", round: "", size: "small" },
                on: { click: _vm.previewOn },
              },
              [_vm._v("预览试卷")]
            ),
          ],
          1
        ),
      ]),
      _c(
        "div",
        { staticClass: "main" },
        [
          _c(
            "div",
            { staticClass: "nav-wrap" },
            [
              _c("nav-bar", {
                class: _vm.postionClass,
                attrs: { routers: _vm.routers },
              }),
            ],
            1
          ),
          _vm.showReport
            ? _c("router-view", {
                attrs: {
                  "subject-name": _vm.subjectName,
                  "report-type": _vm.reportType,
                  "student-exam-data": _vm.studentExamData,
                },
                on: {
                  "update:studentExamData": function ($event) {
                    _vm.studentExamData = $event
                  },
                  "update:student-exam-data": function ($event) {
                    _vm.studentExamData = $event
                  },
                },
              })
            : _vm._e(),
        ],
        1
      ),
      _c(
        "yue-dialog",
        {
          attrs: {
            title: "作答信息",
            visible: _vm.previewVisible,
            width: "800px",
          },
          on: {
            "update:visible": function ($event) {
              _vm.previewVisible = $event
            },
          },
        },
        [
          _c("div", { staticClass: "topic-info" }, [
            _c("span", [
              _vm._v("姓名：" + _vm._s(_vm.previewStudentInfo.studentName)),
            ]),
            _c("span", [
              _vm._v("班级：" + _vm._s(_vm.previewStudentInfo.studClass)),
            ]),
            _c("span", [
              _vm._v("学号：" + _vm._s(_vm.previewStudentInfo.studNo)),
            ]),
          ]),
          _vm._l(Object.keys(_vm.previewMap), function (key) {
            return _c(
              "div",
              { key: key },
              [
                _c("p", { staticClass: "topic-title" }, [
                  _vm._v(
                    _vm._s(key) +
                      "（" +
                      _vm._s(_vm.previewMap[key].totalPoint) +
                      "分）"
                  ),
                ]),
                _c(
                  "el-table",
                  {
                    staticStyle: { width: "100%", "margin-bottom": "20px" },
                    attrs: {
                      data: _vm.previewMap[key].list,
                      size: "small",
                      border: "",
                    },
                  },
                  [
                    _c("el-table-column", {
                      attrs: { prop: "date", label: "小题号" },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                _c("span", [
                                  _vm._v(_vm._s(scope.row.question)),
                                ]),
                              ]
                            },
                          },
                        ],
                        null,
                        true
                      ),
                    }),
                    _c("el-table-column", {
                      attrs: {
                        prop: "name",
                        align: "center",
                        label: "学生作答",
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                scope.row.answer &&
                                scope.row.ossUrl.indexOf("none.jpg") > -1
                                  ? _c("span", [
                                      _vm._v(_vm._s(scope.row.answer)),
                                    ])
                                  : scope.row.ossUrl.indexOf("none.jpg") === -1
                                  ? _c(
                                      "div",
                                      {
                                        staticStyle: {
                                          display: "flex",
                                          "flex-direction": "column",
                                          "align-items": "center",
                                        },
                                      },
                                      _vm._l(
                                        scope.row.ossUrlList,
                                        function (img, imgIndex) {
                                          return _c("el-image", {
                                            key:
                                              scope.$index + "img" + imgIndex,
                                            staticStyle: {
                                              height: "100px",
                                              "margin-bottom": "10px",
                                            },
                                            attrs: {
                                              alt: "answer",
                                              src: img,
                                              "preview-src-list":
                                                scope.row.ossUrlList,
                                            },
                                          })
                                        }
                                      ),
                                      1
                                    )
                                  : _c("span", [_vm._v("-")]),
                              ]
                            },
                          },
                        ],
                        null,
                        true
                      ),
                    }),
                    _c("el-table-column", {
                      attrs: { prop: "address", label: "标准答案" },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                _c("span", [
                                  _vm._v(_vm._s(scope.row.standAnswer || "-")),
                                ]),
                              ]
                            },
                          },
                        ],
                        null,
                        true
                      ),
                    }),
                    _c("el-table-column", {
                      attrs: { prop: "address", label: "得分" },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                _c("span", [
                                  _vm._v(
                                    _vm._s(
                                      scope.row.realScore === null
                                        ? "-"
                                        : scope.row.realScore
                                    )
                                  ),
                                ]),
                              ]
                            },
                          },
                        ],
                        null,
                        true
                      ),
                    }),
                  ],
                  1
                ),
              ],
              1
            )
          }),
        ],
        2
      ),
      _c("el-image", {
        ref: "priview",
        staticClass: "priview-img",
        attrs: {
          src: _vm.previewImg.src,
          "preview-src-list": _vm.previewImg.list,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }